import React from 'react';
import { ParticipantHubLayout } from './ParticipantHubLayout';
import { motion } from 'framer-motion';
import { RadioIcon, ClockIcon, MapPinIcon, MessageSquareIcon, SparklesIcon, BarChartIcon, ArrowRightIcon } from 'lucide-react';
export function LiveCompanionPage() {
  return <ParticipantHubLayout data-id="element-4822">
      <div className="p-6 lg:p-8 max-w-6xl mx-auto space-y-6" data-id="element-4823">
        {/* Live Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-4824">
          <div data-id="element-4825">
            <div className="flex items-center gap-2 mb-2" data-id="element-4826">
              <span className="relative flex h-3 w-3" data-id="element-4827">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75" data-id="element-4828"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-rose-500" data-id="element-4829"></span>
              </span>
              <span className="text-xs font-bold text-rose-600 tracking-wider uppercase" data-id="element-4830">
                Live Now
              </span>
              <span className="text-xs font-medium text-slate-400 ml-2" data-id="element-4831">
                SESSION 3 OF 8
              </span>
            </div>
            <h1 className="font-serif-display text-4xl text-slate-900" data-id="element-4832">
              AI Integration Frameworks
            </h1>
          </div>
          <div className="flex items-center gap-3 bg-white px-4 py-2 rounded-xl border border-slate-200 shadow-sm" data-id="element-4833">
            <ClockIcon className="w-4 h-4 text-amber-500" data-id="element-4834" />
            <span className="text-sm font-bold text-slate-700" data-id="element-4835">
              45 mins remaining
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-4836">
          {/* Main Content Area */}
          <div className="lg:col-span-2 space-y-6" data-id="element-4837">
            {/* Session Info Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm" data-id="element-4838">
              <div className="flex items-start justify-between mb-6" data-id="element-4839">
                <div data-id="element-4840">
                  <h2 className="text-lg font-bold text-slate-900 mb-1" data-id="element-4841">
                    Operationalizing AI in Q4
                  </h2>
                  <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-4842">
                    <span className="flex items-center gap-1" data-id="element-4843">
                      <MapPinIcon className="w-4 h-4" data-id="element-4844" />
                      Grand Ballroom B
                    </span>
                    <span data-id="element-4845">Facilitator: Dr. Sarah Chen</span>
                  </div>
                </div>
                <div className="w-12 h-12 rounded-full bg-slate-100 overflow-hidden" data-id="element-4846">
                  <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=200&q=80" alt="Facilitator" className="w-full h-full object-cover" data-id="element-4847" />
                </div>
              </div>

              {/* Note Taking Area */}
              <div className="bg-slate-50 rounded-xl border border-slate-200 p-4" data-id="element-4848">
                <textarea placeholder="Take a private note... (Saved automatically to your Action Plan)" className="w-full h-32 bg-transparent border-none resize-none focus:ring-0 text-slate-700 placeholder:text-slate-400 text-sm" data-id="element-4849" />
                <div className="flex justify-between items-center mt-2 pt-2 border-t border-slate-200" data-id="element-4850">
                  <span className="text-xs text-slate-400" data-id="element-4851">Saved just now</span>
                  <button className="text-sm font-medium text-amber-600 hover:text-amber-700" data-id="element-4852">
                    Expand Editor
                  </button>
                </div>
              </div>
            </motion.div>

            {/* AI Companion Chat */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="bg-[#0B1B3B] rounded-2xl p-6 shadow-lg text-white" data-id="element-4853">
              <div className="flex items-center gap-2 mb-4" data-id="element-4854">
                <SparklesIcon className="w-5 h-5 text-amber-400" data-id="element-4855" />
                <h3 className="font-serif-display text-xl" data-id="element-4856">
                  Ask the AI Companion
                </h3>
              </div>
              <p className="text-sm text-slate-300 mb-4" data-id="element-4857">
                Ask questions about the current framework, request examples, or
                get context from the pre-reads.
              </p>
              <div className="relative" data-id="element-4858">
                <input type="text" placeholder="E.g., How does this apply to the engineering team?" className="w-full bg-white/10 border border-white/20 rounded-xl py-3 pl-4 pr-12 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:border-amber-400 transition-colors" data-id="element-4859" />
                <button className="absolute right-2 top-1/2 -translate-y-1/2 p-2 bg-amber-500 rounded-lg text-[#0B1B3B] hover:bg-amber-400 transition-colors" data-id="element-4860">
                  <ArrowRightIcon className="w-4 h-4" data-id="element-4861" />
                </button>
              </div>
            </motion.div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6" data-id="element-4862">
            {/* Live Poll */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm" data-id="element-4863">
              <div className="flex items-center gap-2 mb-4" data-id="element-4864">
                <BarChartIcon className="w-5 h-5 text-amber-500" data-id="element-4865" />
                <h3 className="font-bold text-slate-900" data-id="element-4866">Live Poll</h3>
              </div>
              <p className="text-sm text-slate-700 mb-4 font-medium" data-id="element-4867">
                What is your biggest barrier to AI adoption?
              </p>
              <div className="space-y-3" data-id="element-4868">
                {[{
                label: 'Data Privacy / Security',
                percent: 45
              }, {
                label: 'Lack of Internal Skills',
                percent: 30
              }, {
                label: 'Unclear ROI',
                percent: 15
              }, {
                label: 'Other',
                percent: 10
              }].map((option, i) => <div key={i} className="relative" data-id="element-4869">
                    <div className="flex justify-between text-xs font-medium mb-1 relative z-10 px-2" data-id="element-4870">
                      <span className="text-slate-700" data-id="element-4871">{option.label}</span>
                      <span className="text-slate-500" data-id="element-4872">{option.percent}%</span>
                    </div>
                    <div className="h-8 bg-slate-50 rounded-lg overflow-hidden absolute inset-0" data-id="element-4873">
                      <div className="h-full bg-amber-100 rounded-lg transition-all duration-1000" style={{
                    width: `${option.percent}%`
                  }} data-id="element-4874" />
                    </div>
                  </div>)}
              </div>
              <div className="mt-4 text-center text-xs text-slate-400" data-id="element-4875">
                28 of 32 participants have voted
              </div>
            </motion.div>

            {/* Up Next */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm" data-id="element-4876">
              <h3 className="font-bold text-slate-900 mb-4" data-id="element-4877">Up Next</h3>
              <div className="space-y-4" data-id="element-4878">
                <div className="flex gap-3" data-id="element-4879">
                  <div className="text-xs font-bold text-slate-400 w-12 pt-0.5" data-id="element-4880">
                    11:30
                  </div>
                  <div data-id="element-4881">
                    <div className="text-sm font-bold text-slate-900" data-id="element-4882">
                      Coffee Break
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-4883">Terrace</div>
                  </div>
                </div>
                <div className="flex gap-3" data-id="element-4884">
                  <div className="text-xs font-bold text-slate-400 w-12 pt-0.5" data-id="element-4885">
                    11:45
                  </div>
                  <div data-id="element-4886">
                    <div className="text-sm font-bold text-slate-900" data-id="element-4887">
                      Breakout: Department Planning
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-4888">Various Rooms</div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </ParticipantHubLayout>;
}